(ns practitest.frontend.components2.dashboard.charts.readiness-gauge
  (:require [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.svg :refer [render!]]
            [practitest.frontend.components2.dashboard.charts.gauge :as gauge]))

(def ^:private tooltip-text
  "Readiness Score is based on Coverage, Execution, and Remaining
  Defects, with weights shifting during the sprint, giving higher
  weight to defects toward the end. ")

(defmethod p/render! ::chart/readiness-gauge [chart ctx svg-el]
  (let [chart (merge gauge/config ctx chart)]
    (->> (assoc chart :label         "Readiness Score"
                      :status-icon   true
                      :value         (:rrqi chart)
                      :display-value (:rrqi chart)
                      :tooltip-text  tooltip-text)
         gauge/svg
         (render! svg-el))))